// extracted by mini-css-extract-plugin
export default {"futureRoutineQueueFailPopover":"futureRoutineQueueFailPopover-Wy3X6","trigger":"trigger-nVdrR","icon":"icon-eGb02","text":"text-TvdE8","popover":"popover-eltwW","info":"info-v0Hh_"};